import { render, staticRenderFns } from "./AssetUpload.vue?vue&type=template&id=3e0811d7&scoped=true"
import script from "./AssetUpload.vue?vue&type=script&lang=js"
export * from "./AssetUpload.vue?vue&type=script&lang=js"
import style0 from "./AssetUpload.vue?vue&type=style&index=0&id=3e0811d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0811d7",
  null
  
)

export default component.exports